<template lang="">
    <div>
     <div class="upload-container">
        <div class="common upload-top">
            <p class="top-title">著录内容AI审核</p>
            <van-loading style='margin-top:1.23rem;' size="24px" type="spinner" vertical>审核中...</van-loading>
        </div>

         <div class="common upload-bottom">
             <p>温馨提示</p>
             <p>1. 资源审核中，请勿关闭页面，审核完成后将自动进行下 一步操作。</p>
             <p>2. AI会对内容进行涉黄涉政涉暴判定，违规内容将被自动 删除，不会进入后续流程，申诉请联系客服。</p>
         </div>
  
     </div>
 
     <div class="upload-btn">
         <div class="check-btnA">
             <span>自动执行中，完成后将进入下一步</span>
         </div>
     </div>
     <div class="naviPosition" />
     <div class="digNavigate bottom">
       <router-link class="navItm" :to="{ name: 'Waphome' }">
         <img src="../../../images/home.png" class="img-normal">
         <img src="../../../images/home_select.png" class="img-active">
         <label>首页</label>
       </router-link>
       <router-link class="navItm" :to="{ name: 'Waplist' }">
         <img src="../../../images/res.png" class="img-normal">
         <img src="../../../images/res_select.png" class="img-active">
         <label>特藏</label>
       </router-link>
       <router-link class="navItm active" :to="{ name: 'Wapcertified' }">
         <img src="../../../images/upload.jpg" class="img-normal">
         <img src="../../../images/upload_select.jpg" class="img-active">
         <label>上传</label>
       </router-link>
       <router-link class="navItm" :to="{ name: 'Wapuser' }">
         <img src="../../../images/use.png" class="img-normal">
         <img src="../../../images/use_select.png" class="img-active">
         <label>我的</label>
       </router-link>
     </div>
    </div>
 </template>
 <script>
 import {
  aiTask,
  textAudit
} from '@/api/library'
 export default {
    data() {
        return {
        fileList: [],
        time: null
        }
    },
    mounted() {

        this.textAudit()
    },
     beforeDestroy() {

        if (this.time != null) {
        clearInterval(this.time)
        this.time = null
        }
    },
     methods:{
         async textAudit() {

            const res = await textAudit({
                ids: this.$route.query.collectionId,
                status: 5//this.nextStatus
            })
            if (res.data) {
                this.timeSend()
            }
        },
        changeData() {
        this.$router.push({
            path: '/single',
            query: {
            collectionId: 0,
            status: 'upload'
            }
        })
        this.uploadnext()
        },
        timeSend() {
        this.time = setInterval(() => {
            this.aiTask()
        }, 10000)
        },
        async aiTask() {
        const res = await aiTask({
            ids: this.$route.query.collectionId,
            type: 'cataloging'
        })
        if (res.data != null) {
            if (res.data.length === 0) {
            if (this.time != null) {
                clearInterval(this.time)
                this.time = null
            }
            return
            }
            this.fileList = res.data[0].aiTaskResourceVOS

            if (res.data[0].status === 2) {
            if (this.time != null) {
                clearInterval(this.time)
                this.time = null
            }
            // this.uploadnext()
              this.$router.push({
                    path:'/wap/success',
                    query:{
                        collectionId:this.$route.query.collectionId
                    }
                })
            }
        }
        },
     },
 }
 </script>
 <style src="@/styles/wap.scss" lang="scss" scoped></style>
 <style scoped>
     .upload-container {
         box-sizing: border-box;
         width: 100%;
         /* padding-left: 0.3333rem;
         padding-right: 0.3333rem;
         padding-top: 0.3704rem; */
         padding: 0.3704rem 0.3333rem 0.3241rem 0.3333rem;
         background: #eee;
     }
     
     .flex {
         display: flex;
     }
 
     .common {
         width: 100%;
         background: #FFFFFF;
         box-shadow: 0px 0.0463rem 0.1389rem 0px rgba(0,0,0,0.05);
         border-radius: 0.1111rem;
     }
     .upload-top {
         box-sizing: border-box;
         height: 5.037rem;
         margin-bottom: 0.2778rem;
         padding-left: 0.3704rem;
         padding-top: 0.3704rem;
         padding-right: 0.3704rem;
     }
     .top-title {
         height: 0.4259rem;
         font-size: 0.4444rem;
         font-weight: 700;
         color: #4C70E8;
     }
     .top-list {
         margin-top: 0.4352rem;
         width: 100%;
         height: 0.4074rem;
         border-top: 1px solid #F3F4F9;
         border-bottom: 1px solid #F3F4F9;
         /* padding-left: 1.2593rem;
         padding-right: 0.3704rem; */
     }
     .top-list span {
         font-size: 0.3333rem;
         font-weight: 400;
         color: #7B84A1;
         line-height: 0.4074rem;
         opacity: 0.5;
     }
     .top-list span:first-child{
         margin-right: 3.7685rem;
         margin-left: 1.2593rem;
     }
     .top-list span:last-child{
         margin-left: 0.3056rem;
     }
     .upload-bottom {
         box-sizing: border-box;
         height: 3.8333rem;
         padding-left: 0.3704rem;
         padding-right: 0.3704rem;
         font-size: 0.3333rem;
         padding-top: 0.3704rem;
     }
     .upload-bottom p:first-child{
         /* margin-top: 0.3704rem; */
         height: 0.4259rem;
         font-size: 0.4444rem;
         font-weight: 700;
         color: #4C70E8;
     }
     .upload-bottom p:nth-child(2){
         margin-top: 0.463rem;
         height: 0.8889rem;
         font-size: 0.3333rem;
         line-height: 0.5185rem;
         
     }
     .upload-bottom p:nth-child(3){
         margin-top: 0.3333rem;
         height: 0.8889rem;
         font-size: 0.3333rem;
         line-height: 0.5185rem;
         
     }
     .upload-bottom p:last-child{
         margin-top: 0.3333rem;
         font-size: 0.3333rem;
         line-height: 0.5185rem;
     }
     .upload-btn {
         width: 100%;
         height: 1.6667rem;
         position: absolute;
         bottom:1.35rem;;
         box-sizing: border-box;
         padding: 0.3704rem 0.3333rem 0.3704rem 0.3333rem;
         background: #FFFFFF;
         font-size: 0.3333rem;
         font-weight: 700;
         color: #FFFFFF;
     }
     .check-btnA {
         width: 100%;
         height: 0.9259rem;
         background:  #7B84A1;
         border-radius: 0.1111rem;
         text-align: center;
         line-height: 0.9259rem;
     }
     .check-btnB {
         width: 100%;
         height: 0.9259rem;
         background: #4C70E8;
         border-radius: 0.1111rem;
         text-align: center;
         line-height: 0.9259rem;
     }
     .bottom {
        border-top:  1px solid #F3F4F9;
     }
 </style>